import { SVGProps } from 'react';

const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 16" {...props}>
    <path
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2M1 3v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3M1 3l9 6 9-6"
    />
  </svg>
);
export default SvgMail;
